import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Typography,
  Radio,
  Pagination,
  Grid,
} from "@mui/material";
import api_service from "../../../network/api_callbacks";
import MultimediaItem from "./MultimediaItem ";

const MultimediaDialog = ({ open, onClose, selectedItem, onSelect }) => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  const fetchData = async (pageNo = 1, searchQuery = "") => {
    setLoading(true);
    try {
      const response = await api_service.getTambolaMultimediaList({
        _page: pageNo,
        _limit: 10,
        //...(searchQuery ? { search: searchQuery } : {}),
      });

      setData(response?.data || []);
      setPagination(response?.pagination || null);
    } catch (err) {
      console.error("Failed to fetch multimedia:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchData(1, search);
    }
  }, [open]);

  const handlePageChange = (event, value) => {
    setPage(value);
    fetchData(value, search);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
    fetchData(1, e.target.value);
  };

  const handleConfirm = () => {
    const selected = data.find((item) => item._id === selectedId);
    onSelect(selected);
    onClose();
  };

  const ShowMultimediaList = () => {
        const [activeVideoId, setActiveVideoId] = useState(null);
        return (
            <Grid container spacing={2} justifyContent="flex-start" alignItems="center" marginBottom={4} marginTop={2}>
                {data?.map((item) => {
                    return (
                        <MultimediaItem
                            key={item?._id}
                            item={item}
                            isActive={(activeVideoId === item?._id)}
                            isSelected={selectedItem?._id === item?._id || selectedId === item?._id}
                            onPlay={() => setActiveVideoId(item?._id)}
                            onClick={() => {
                                setSelectedId(item?._id);
                            }}
                        />
                    )
                })}
            </Grid>
        )
    }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Select Multimedia</DialogTitle>
      <DialogContent>
        {/* Search */}
        {/* <Box mb={2}>
          <TextField
            fullWidth
            placeholder="Search multimedia..."
            value={search}
            onChange={handleSearch}
          />
        </Box> */}

        {/* Items */}
        {loading ? (
          <Typography>Loading...</Typography>
        ) : (
          <Box display="flex" flexDirection="column" gap={2}>
            <ShowMultimediaList />
          </Box>
        )}

        {/* Pagination */}
        {pagination && (
          <Box mt={3} display="flex" justifyContent="center">
            <Pagination
              count={pagination.totalPages}
              page={page}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button 
        variant="contained"
        color="primary"
        onClick={onClose}
        >
            Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          disabled={!selectedId}
          variant="contained"
          color={!selectedId?"secondary":"primary"}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MultimediaDialog;
